import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAssessmentResultsAPI } from "./assessmentResultsAPI";

// ✅ Get Assessment Results
export const getAssessmentResults = createAsyncThunk(
  "assessmentResults/list",
  async (params, { rejectWithValue }) => {
    try {
      const { search = "" } = params || {};
      const response = await getAssessmentResultsAPI({ search });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch assessment results");
    }
  }
);

const initialState = {
  getAssessmentResults: { data: [], total: 0, loading: false, error: null },
};

const assessmentResultsSlice = createSlice({
  name: "assessmentResults",
  initialState,
  reducers: {
    clearAssessmentResults: (state) => {
      state.getAssessmentResults.data = [];
      state.getAssessmentResults.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAssessmentResults.pending, (state) => {
        state.getAssessmentResults.loading = true;
        state.getAssessmentResults.error = null;
      })
      .addCase(getAssessmentResults.fulfilled, (state, action) => {
        state.getAssessmentResults.loading = false;
        state.getAssessmentResults.data = action.payload?.data || [];
        state.getAssessmentResults.total =
          action.payload?.total || action.payload?.count || (action.payload?.data ? action.payload.data.length : 0);
      })
      .addCase(getAssessmentResults.rejected, (state, action) => {
        state.getAssessmentResults.loading = false;
        state.getAssessmentResults.error = action.payload;
      });
  },
});

export const { clearAssessmentResults } = assessmentResultsSlice.actions;

export default assessmentResultsSlice.reducer;
